import React from 'react'
import PropTypes from 'prop-types'
import Checkbox from 'assets/icon/checkbox.svg'

const Criteria = ({ data, title }) => {
  return (
    <div className="bg-white p-3 border !border-[#F79009] mt-3 rounded-4">
      <b className="text-[#F67443] font-emibold mb-2 block">{title}</b>
      <div className="grid grid-cols-2 gap-3">
        {data.map(({ label, key }) => (
          <div key={key} className="flex items-center gap-2">
            <img src={Checkbox} alt="Checkpoint" />
            <span className="text-[#F67443] text-sm">{label}</span>
          </div>
        ))}
      </div>
    </div>
  )
}
Criteria.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      key: PropTypes.string.isRequired,
    })
  ).isRequired,
  title: PropTypes.string.isRequired,
}
export default React.memo(Criteria)
